import { isNil } from "lodash";
import React from "react";

import { ORIENTATION_ROW } from "../../constants/identifiers";
import Dimensions from "../../constants/styles/dimensions";
import WorkView from "./index";

/* eslint-disable react/display-name */

let workViewParamsForView = null;

// #!if iOS === true
// workViewParamsForView = view => {
// return {
// viewId: view.viewId,
// label: view.label,
// labelColor: view.labelColor,
// isActive: view.isActive,
// isFilterActive: view.isFilterActive,
// storedSize: view.storedSize,
// allowFilter: false,
// allowSplitHorizontal: false,
// allowSplitVertical: false,
// allowMinimize: false,
// allowClose: false
// };
// };
// #!elseif harvard === true
workViewParamsForView = (view, siblingCount, maxHorizontalCount, maxVerticalCount, layoutDepth, layoutOrientation) => {
  return {
    viewId: view.viewId,
    label: view.label,
    labelColor: view.labelColor,
    isActive: view.isActive,
    isFilterActive: view.isFilterActive,
    isMinimized: view.size ? view.size.height <= Dimensions.COLLAPSE_WORKVIEW_HEIGHT : false,
    storedSize: view.storedSize,
    allowMinimize: layoutOrientation === ORIENTATION_ROW && (layoutDepth > 0 || siblingCount > 1),
    allowFilter: false,
    allowSplitHorizontal: false,
    allowSplitVertical: false,
    allowClose: false
  };
};
//#!else
// workViewParamsForView = (view, siblingCount, maxHorizontalCount, maxVerticalCount, layoutDepth, layoutOrientation) => {
// const isHorizontal = layoutOrientation === ORIENTATION_ROW;
// return {
// viewId: view.viewId,
// label: view.label,
// labelColor: view.labelColor,
// isActive: view.isActive,
// isFilterActive: view.isFilterActive,
// isMinimized: view.size.height <= Dimensions.COLLAPSE_WORKVIEW_HEIGHT,
// storedSize: view.storedSize,
// allowMinimize: layoutOrientation === ORIENTATION_ROW && (layoutDepth > 0 || siblingCount > 1),
// allowFilter: true,
// allowSplitHorizontal: maxHorizontalCount > (isHorizontal ? siblingCount : 1),
// allowSplitVertical: maxVerticalCount > (!isHorizontal ? siblingCount : 1),
// allowClose: layoutDepth > 0 || siblingCount > 1
// };
// };
// #!endif

const wrapWorkView = (
  childComponent,
  view,
  siblingCount,
  maxHorizontalCount,
  maxVerticalCount,
  layoutDepth,
  handlers,
  editTitleOperation,
  layoutOrientation
) => {
  const params = workViewParamsForView(
    view,
    siblingCount,
    maxHorizontalCount,
    maxVerticalCount,
    layoutDepth,
    layoutOrientation
  );
  const viewId = params.viewId;

  const viewHeight = view.size && !isNil(view.size.height) ? view.size.height : null;
  // if the view is collapsed
  const shownChildComponent = !isNil(viewHeight)
    ? viewHeight > Dimensions.COLLAPSE_WORKVIEW_HEIGHT
      ? childComponent
      : null
    : childComponent;

  return (
    <WorkView
      key={params.viewId}
      {...params}
      onClick={handlers.onClick ? () => handlers.onClick(viewId) : null}
      onClose={handlers.onClose ? () => handlers.onClose(viewId) : null}
      onMinimize={handlers.onMinimize ? () => handlers.onMinimize(viewId) : null}
      onPopout={handlers.onPopout ? () => handlers.onPopout(viewId) : null}
      onSplitHorizontal={handlers.onSplitHorizontal ? () => handlers.onSplitHorizontal(viewId) : null}
      onSplitVertical={handlers.onSplitVertical ? () => handlers.onSplitVertical(viewId) : null}
      onFilter={handlers.onFilter ? () => handlers.onFilter(viewId) : null}
      onResize={handlers.onResize ? newSize => handlers.onResize(viewId, newSize) : null}
      onEditTitle={editTitleOperation ? title => editTitleOperation(title) : null}
    >
      {shownChildComponent}
    </WorkView>
  );
};
export default wrapWorkView;
